var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"box"},[_c('header-com'),_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,staticClass:"img",attrs:{"src":item.path},on:{"click":function($event){return _vm.toDetail(item,index-1)}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }